import { PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { type ButtonProps, DialogRoot, useDialogTriggerState } from '@gitbook/spine-react';

import {
    CreateSiteSectionGroupDialog,
    type CreateSiteSectionGroupDialogProps,
} from './CreateSiteSectionGroupDialog';
import { type UseMoveSiteSectionsProps, useMoveSiteSections } from './useMoveSiteSections';

interface MoveSiteSectionsButtonProps
    extends Omit<UseMoveSiteSectionsProps, 'createSiteSectionGroupDialogTrigger'>,
        CreateSiteSectionGroupDialogProps,
        Pick<ButtonProps, 'className' | 'label' | 'size'> {}

export function MoveSiteSectionsButton(props: MoveSiteSectionsButtonProps) {
    const { className, label, size, ...rest } = props;
    const createSiteSectionGroupDialogTrigger = useDialogTriggerState();
    const moveSiteSections = useMoveSiteSections({
        ...rest,
        createSiteSectionGroupDialogTrigger,
    });
    return (
        <>
            <DialogRoot {...createSiteSectionGroupDialogTrigger.rootProps}>
                <CreateSiteSectionGroupDialog {...rest} />
            </DialogRoot>
            <PaletteButton
                palette={() => moveSiteSections(rest.siteSections)}
                kind="secondary"
                leadingIcon={Icon.ArrowRight}
                className={className}
                label={label}
                size={size}
            />
        </>
    );
}
